//src/components/forCASolutionsData
import colorSquare from '../assets/doc_logo.jpg';

const forCASolutionsData = [
    {
        id: 1,
        title: "Efficient Document Management:",
        text: "Doclivo provides a structured system for storing and managing financial documents such as tax returns, financial statements, invoices, receipts, and contracts. Digitizing and organizing these documents in a centralized platform makes them easily accessible when needed, saving you time and effort.",
        image: colorSquare,
        buttonLabel: "Learn more",
    },
    {
        id: 2,
        title: "Streamlined Workflow:",
        text: "With Doclivo, you can automate repetitive tasks such as data entry and report generation, freeing up valuable time for more strategic activities like analysis and advising. This automation not only increases efficiency but also reduces the risk of manual errors.",
        image: colorSquare,
        buttonLabel: "Learn more",
    },
    {
        id: 3,
        title: "Customizable Reporting:",
        text: "Doclivo has efficient reporting and analytics capabilities, allowing you to generate custom reports tailored to your clients' needs. Analyze financial data, track trends, and gain insights to support decision-making with ease.",
        image: colorSquare,
        buttonLabel: "Learn more",
    },

    // Add more items as needed

];

export default forCASolutionsData;